<template>
  <el-table
    :data="$props.accounts"
    stripe
  >
    <el-table-column
      v-if="!!$scopedSlots['peek']"
      type="expand"
    >
      <template v-slot="{ row }">
        <slot
          name="peek"
          :account="row"
        />
      </template>
    </el-table-column>

    <el-table-column
      show-overflow-tooltip
      label="Account"
    >
      <template v-slot="{ row }">
        <RouterLink :to="{ name: 'customerservice-accounts-account', params: { accountId: row.id } }">
          {{ row.name }}
        </RouterLink>
      </template>
    </el-table-column>

    <el-table-column
      show-overflow-tooltip
      label="Account Manager"
    >
      <template v-slot="{ row }">
        <v-popover
          v-if="row.account_manager"
          placement="top"
          trigger="hover"
        >
          <template slot="popover">
            <span class="text-uppercase">
              <b>Phone Number</b><br>
              <span>{{ row.account_manager.phone_primary || '-' }}</span>

              <div class="clearfix my-2" />

              <b>Email Address</b><br>
              <span>{{ row.account_manager.email || '-' }}</span>
              <br>
            </span>
          </template>

          <u>
            {{ row.account_manager.name }}
          </u>
        </v-popover>

        <template v-else>
          -
        </template>
      </template>
    </el-table-column>

    <el-table-column
      show-overflow-tooltip
      label="Billing Group"
      :formatter="row => $_.get(row, 'b_group.long', '-')"
    />

    <el-table-column
      label="Standing"
      align="center"
      :width="120"
    >
      <template v-slot="{ row }">
        <el-tag
          :type="getStandingTagType(row.crm_endangered)"
          size="mini"
        >
          {{ getStandingDescription(row.crm_endangered) }}
        </el-tag>
      </template>
    </el-table-column>

    <el-table-column
      label="Grade"
      align="center"
      :width="120"
    >
      <template v-slot="{ row }">
        <el-tag
          :type="getGradeTagType($_.get(row, 'crm_account_grade'))"
          size="mini"
        >
          {{ getGradeDescription($_.get(row, 'crm_account_grade')) }}
        </el-tag>
      </template>
    </el-table-column>

    <el-table-column
      label="Status"
      align="center"
      :width="120"
    >
      <template v-slot="{ row }">
        <el-tag
          :type="getStatusTagType($_.get(row, 'status'))"
          size="mini"
        >
          {{ $_.get(row, 'status') | titleize }}
        </el-tag>
      </template>
    </el-table-column>

    <el-table-column
      v-if="!!$scopedSlots['actions']"
      label="Actions"
      align="left"
    >
      <template v-slot="{ row }">
        <slot
          name="actions"
          :account="row"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    accounts: {
      type: Array,
      required: true
    }
  },
  methods: {
    getStatusTagType (status) {
      switch (status) {
        case 'on hold':
          return 'danger'
        default:
          return 'info'
      }
    },
    getGradeTagType (grade) {
      switch (grade) {
        case 1:
        case 6:
          return 'success'
        case 2:
        case 3:
          return 'warning'
        case 4:
          return 'danger'
        case 5:
        default:
          return 'info'
      }
    },
    getStandingTagType (standing) {
      switch (standing) {
        case -1:
          return 'success'
        case 1:
          return 'danger'
        default:
          return 'info'
      }
    },
    getStandingDescription (standing) {
      switch (standing) {
        case -1:
          return 'New'
        case 1:
          return 'Endangered'
        default:
          return 'Healthy'
      }
    },
    getGradeDescription (grade) {
      switch (grade) {
        case 1:
          return 'A'
        case 2:
          return 'B'
        case 3:
          return 'C'
        case 4:
          return 'D'
        case 6:
          return 'HC'
        case 5:
        default:
          return 'No Trade'
      }
    }
  }
}
</script>
